import React from "react";

import { ExpandableSportCategoryMenuItem } from "./ExpandableSportCategoryMenuItem";

import PropTypes from "prop-types";

export const KambiAllSportsMenuItem = ({ item, trackingInfo }) => {
  return (
    <ExpandableSportCategoryMenuItem
      automationId="uc-all-sports"
      item={item}
      trackingInfo={trackingInfo}
    />
  );
};

KambiAllSportsMenuItem.propTypes = {
  item: PropTypes.object,
  trackingInfo: PropTypes.object
};
